import { render, staticRenderFns } from "./WorkflowStep.vue?vue&type=template&id=af63445a&"
import script from "./WorkflowStep.vue?vue&type=script&lang=js&"
export * from "./WorkflowStep.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports